import React from "react";
import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
import VendorDetailsTab from "./VendorDetailsTab";
import SaaDetailsTab from "./SaaDetailsTab";

const VendorSaaDetails = () => {
  return (
    <Box p={5} bg={useColorModeValue("white", "gray.800")} borderRadius="md" boxShadow="sm">
      <Text fontSize="xl" fontWeight="bold" mb={5} color="blue.700">
        Vendor & Financial Details
      </Text>
      <Tabs variant="enclosed" colorScheme="blue">
        <TabList>
          <Tab fontWeight="semibold">Vendor Details</Tab>
          <Tab fontWeight="semibold">Financial Details</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <VendorDetailsTab />
          </TabPanel>
          <TabPanel>
            <SaaDetailsTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default VendorSaaDetails;
